import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { Outlet } from 'react-router-dom';
import { Layout as LandingLayout } from 'src/layouts/landing';

// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const LandingPost = lazy(() => import('src/pages/landing/post'));

// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const UnsubscribePage = lazy(() => import('src/pages/landing/unsubscribe'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const AttendancePage = lazy(() => import('src/pages/landing/attendance'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const SurveyPage = lazy(() => import('src/pages/landing/survey'));

// eslint-disable-next-line react-refresh/only-export-components
const TermsOfServicePage = lazy(() => import('src/pages/legal/terms'));
// eslint-disable-next-line react-refresh/only-export-components
const PrivacyPolicyPage = lazy(() => import('src/pages/legal/privacy'));

export const landingRoutes: RouteObject[] = [
  {
    path: 'landing',
    element: (
      <LandingLayout>
        <Outlet />
      </LandingLayout>
    ),
    children: [
      {
        path: 'post/:token',
        element: <LandingPost />
      }
    ]
  },
  {
    path: 'unsubscribe',
    element: (
      <LandingLayout>
        <UnsubscribePage />
      </LandingLayout>
    )
  },
  {
    path: 'attendance',
    element: (
      <LandingLayout>
        <AttendancePage />
      </LandingLayout>
    )
  },
  {
    path: 'survey',
    element: (
      <LandingLayout>
        <SurveyPage />
      </LandingLayout>
    )
  },
  {
    path: 'terms',
    element: (
      <LandingLayout>
        <TermsOfServicePage />
      </LandingLayout>
    )
  },
  {
    path: 'privacy',
    element: (
      <LandingLayout>
        <PrivacyPolicyPage />
      </LandingLayout>
    )
  }
];
